import { tabIcons, tabTemplate, categoryCodeTab } from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import CataloguePanel from '../components/CataloguePanel';

export default {
  ...tabTemplate('catalogue', CataloguePanel, matchCodeUrl(['catalogues'])),
  ...tabIcons('book'),
  access: ({ datasets }) => datasets.read,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 210,
};
